module.exports = __webpack_public_path__ + "img/44.51ced4d6.jpg";